const ChatStatus = {
  accepted: 'accepted',
  rejected: 'rejected',
  invited: 'invited',
};

export default ChatStatus;
